import { useState, useEffect } from 'react';
import { authAPI } from '../api/auth';

let cachedPairs = null;
let loadPromise = null;

export async function fetchPairsConfig() {
  if (cachedPairs) {
    return cachedPairs;
  }
  if (!loadPromise) {
    loadPromise = authAPI
      .getPairsConfig()
      .then((res) => {
        if (res.success && res.data) {
          cachedPairs = res.data;
          return cachedPairs;
        }
        throw new Error(res.message || 'Could not load pairs config');
      })
      .finally(() => {
        loadPromise = null;
      });
  }
  return loadPromise;
}

export function clearPairsConfigCache() {
  cachedPairs = null;
  loadPromise = null;
}

export function usePairsConfig() {
  const [pairsData, setPairsData] = useState(cachedPairs);
  const [loading, setLoading] = useState(!cachedPairs);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchPairsConfig()
      .then((data) => {
        if (!cancelled) {
          setPairsData(data);
          setError(null);
        }
      })
      .catch((e) => {
        if (!cancelled) {
          setError(e.message || 'Could not load pairs config');
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const overviewPairs = pairsData?.overviewPairs || [];
  const allPairs = pairsData?.pairs || [];

  return { pairsData, overviewPairs, allPairs, loading, error };
}
